import { PropsWithChildren } from 'react';

export default function SectionBody({ children }: PropsWithChildren) {
  return (
    <div className='flex-1 flex flex-col gap-2 w-full h-full items-start justify-center'>
      {children}
    </div>
  );
}
